import { useEffect, useState } from "react";
import _ from "lodash";
import { useTranslation } from "react-i18next";
import { Box, Grid2, Link, Stack, Typography, useTheme } from "@mui/material";
import { enqueueSnackbar } from "notistack";
import { EGBasicSelect } from "../../../../MainComponents/Select/EGBasicSelect";
import { EGInput } from "../../../../MainComponents/Input/EGInput";
import { EGButton } from "../../../../MainComponents/Button/EGButton/EGButton";
import { InvestigationButton } from "../components/InvestigationButton";
import { returnIsValid, useConstants } from "../Main/useConstants";
import { Roles } from "./Modals/Roles";
import { initAccessResource, initFinancialResource, initHumanResource, initMaterialResource } from "./schemas";

// Funcion revisar el formulario y retornar si es valido y cuales son los errores
const validateForm = (type, resource) => {
  const errors = {};
  if (type === "access" || type === "material") {
    if (resource.resource.trim() === "") errors.resource = true;
  }
  if (type === "financial") {
    if (resource.resource.trim() === "") errors.resource = true;
    if (resource.amount.trim() === "") errors.amount = true;
    if (isNaN(resource.amount)) errors.amount = true;
  }
  if (type === "human") {
    if (resource.name.trim() === "") errors.name = true;
    if (resource.expertise.trim() === "") errors.expertise = true;
    if (resource.collaborator.trim() === "") errors.collaborator = true;
  }
  return [
    Object.entries(errors).length === 0 ? true : false,
    errors
  ];
}

// SECCIONES DE AGREGAR O EDITAR -----------------------------
export const AddResource = ({ 
  resources,
  handleSaveResources,
  selectedResource = null,
  setSelectedResource = () => {},
  isLoading,
  isEditing,
  setIsEditing = () => {},
  justForm = false,
}) => {

  const [t] = useTranslation("investigation");
  const theme = useTheme();

  const { resources: { resourceTypeOpts } } = useConstants();

  const [type, setType] = useState("");
  const [triedToSave, setTriedToSave] = useState(false);
  const [errors, setErrors] = useState({});
  const [resource, setResource] = useState({});

  useEffect(() => {
    if (isEditing && selectedResource) {
      setType(selectedResource.key);
      const findedResource = _.get(resources, `${selectedResource.key}.${selectedResource.idx}`);
      setResource(findedResource)
    }
  }, [selectedResource]);

  const handleClose = () => {
    setSelectedResource(null);
    setIsEditing(false);
  }

  const handleAddResource = async () => {
    setTriedToSave(true);
    const [isValid, errors] = validateForm(type, resource);
    setErrors(errors);
    if (!isValid) {
      enqueueSnackbar({ variant: "error", message: t("resources.missing_required_inputs") });
      return;
    };
    const newResource = {
      ...resource,
      approved: justForm ? true : false,
    }
    const newResources = _.cloneDeep(resources);
    const resourcesOfAKind = _.get(newResources, `${type}`);

    if (Array.isArray(resourcesOfAKind)) {
      resourcesOfAKind.push(newResource);
    } else {
      resourcesOfAKind = [newResource];
    }

    await handleSaveResources(newResources);
    handleClose();
  };

  const handleUpdateResource = async () => {
    setTriedToSave(true);
    const [isValid, errors] = validateForm(type, resource);
    setErrors(errors);
    if (!isValid) {
      enqueueSnackbar({ variant: "error", message: t("resources.missing_required_inputs") });
      return;
    };
    const newResources = _.cloneDeep(resources);
    _.set(newResources, `${selectedResource.key}.${selectedResource.idx}`, resource);
    await handleSaveResources(newResources);
    handleClose();
  }

  const handleChangueResource = (value) => {
    switch (value) {
      case 'access':
        setResource(_.cloneDeep(initAccessResource));
        break;
      case 'financial':
        setResource(_.cloneDeep(initFinancialResource));
        break;
      case 'human':
        setResource(_.cloneDeep(initHumanResource));
        break;
      case 'material':
        setResource(_.cloneDeep(initMaterialResource));
        break;
    }
    setErrors({});
    setTriedToSave(false);
    setType(value);
  }

  const handleChange = (evt, spread, obj) => {
    let newResource;
    if (spread === true && obj) {
      newResource = { ...resource, ...obj };
      setResource(newResource)
    } else {
      const { name, value } = evt.target;
      newResource = { ...resource, [name]: value };
      setResource(newResource);
    }
    if (triedToSave) {
      const [_, errors] = validateForm(type, newResource);
      setErrors(errors);
    }
  }

  return (
    <Box sx={justForm ? { padding: 0 } : { padding: 2 }}>
      {
        !justForm && (
          <Box display="flex" alignItems="center" marginBottom={1.5}>
            <Typography
              fontWeight={600}
              fontSize={16}
              color={theme.palette.ethicsBlue.main}
            >
              {!!selectedResource ? t("resources.add_edit_edit") : t("resources.add_edit_add")}
            </Typography>
            <Box
              flexGrow={1} 
              height="1px" 
              sx={{ 
                backgroundColor: theme.palette.ethicsBlue.main,
                marginLeft: 1
              }}  
            />
          </Box>
        )
      }

      <Grid2 container spacing={2}>
        
        <Grid2 size={{ xs: 12, lg: 6 }}>
          <EGBasicSelect
            label={t("resources.resource_type")}
            value={type}
            onChange={(e) => handleChangueResource(e.target.value)}
            options={resourceTypeOpts}
            required={true}
            isValid={null}
            showHelpText={false}
            disabled={!!selectedResource}
          />
        </Grid2>

        {
          type === "access" && 
          <AccessResourcesEdit
            resource={resource}
            errors={errors}
            handleChange={handleChange}
            triedToSave={triedToSave}
          />
        }
        {
          type === "financial" && 
          <FinancialResourcesEdit
            resource={resource}
            errors={errors}
            handleChange={handleChange}
            triedToSave={triedToSave}
          />
        }
        {
          type === "human" &&
          <HumanResourcesEdit
            resource={resource}
            errors={errors}
            handleChange={handleChange}
            triedToSave={triedToSave}
          />
        }
        {
          type === "material" && 
          <MaterialResourcesEdit
            resource={resource}
            errors={errors}
            handleChange={handleChange}
            triedToSave={triedToSave}
          />
        }


      </Grid2>

      <Stack direction={{ xs: "column", md: "row" }} justifyContent="flex-end" spacing={1} marginTop={2}>
        <InvestigationButton
          label={t("resources.cancel")}
          icon="close_icon"
          onClick={handleClose}
          loading={isLoading}
          />
        <InvestigationButton
          label={t("resources.save")}
          variant="success"
          icon="mark_check_bold"
          onClick={ selectedResource ? handleUpdateResource : handleAddResource}
          disabled={!type}
          loading={isLoading}
        />
      </Stack>
    </Box>
  )
}

// RECURSOS DE ACCESO
const AccessResourcesEdit = ({
  resource,
  errors,
  handleChange,
  triedToSave,
}) => {

  const [t] = useTranslation("investigation");
  const { resources: { accessResourcesOpts } } = useConstants();
  const [activeDetails, setActiveDetails] = useState(!!resource?.details ?? false);

  return (
    <>
      <Grid2 
        size={{ xs: 12, lg: 6 }}
        display="flex"
        alignItems="flex-end"
        flexDirection="column"
      >
        <EGBasicSelect
          label={t("resources.resource")}
          name="resource"
          value={resource?.resource ?? ""}
          onChange={handleChange}
          options={accessResourcesOpts}
          required={true}
          isValid={returnIsValid(errors.resource, triedToSave)}
          showSuccessValidation
          showHelpText={false}
        />
        
        {
          !activeDetails &&
          <Link
            onClick={() => setActiveDetails(true)}
            underline="hover"
            textAlign="end"
            mt={.6}
          >
            {t("resources.add_details_plus")}
          </Link>
        }
      </Grid2>

      {
        activeDetails &&
        <Grid2 size={12}>
          <EGInput
            label={t("resources.details")}
            name="details"
            value={resource?.details ?? ""}
            onChange={handleChange}
            type="textarea"
            multiline
            rows={5}
          />
        </Grid2> 
      }
    </>
  )
} 

// RECURSOS DE FINANCIEROS
const FinancialResourcesEdit = ({
  resource,
  errors,
  handleChange,
  triedToSave,
}) => {
  const [t] = useTranslation("investigation");
  const [activeDetails, setActiveDetails] = useState(!!resource?.details ?? false);
  return (
    <>
      <Grid2 size={{ xs: 12, lg: 6 }}>
        <EGInput
          label={t("resources.resource")}
          name="resource"
          value={resource?.resource ?? ""}
          onChange={handleChange}
          required={true}
          isValid={returnIsValid(errors?.resource, triedToSave)}
          showSuccessValidation
          showHelpText={false}
        />
      </Grid2>

      <Grid2
        size={{ xs: 12, lg: 6 }}
        display="flex"
        alignItems="flex-end"
        flexDirection="column"
      >
        <EGInput
          label={t("resources.amount")}
          name="amount"
          type="number"
          value={resource?.amount ?? ""}
          onChange={handleChange}
          required={true}
          isValid={returnIsValid(errors?.amount, triedToSave)}
          showSuccessValidation
          showHelpText={false}
        />
        {
          !activeDetails &&
          <Link
            onClick={() => setActiveDetails(true)}
            underline="hover"
            textAlign="end"
            mt={.6}
          >
            {t("resources.add_details_plus")}
          </Link>
        }
      </Grid2>

      {
        activeDetails && (
          <Grid2 size={12}>
            <EGInput
              label={t("resources.details")}
              name="details"
              value={resource?.details ?? ""}
              onChange={handleChange}
              type="textarea"
              multiline
              rows={5}
            />
          </Grid2> 
        )
      }
    </>
  )
}

// RECURSOS HUMANOS
const HumanResourcesEdit = ({
  resource,
  errors,
  handleChange,
  triedToSave,
}) => {
  const [t] = useTranslation("investigation");

  const { resources: { collaboratorOpts, expertiseOpts, roles } } = useConstants();

  const [showRoles, setShowRoles] = useState(false);
  const [activeDetails, setActiveDetails] = useState(!!resource?.details ?? false);


  return (
    <>
      <Roles 
        resource={resource}
        roles={roles}
        showRoles={showRoles}
        setShowRoles={setShowRoles}
        handleChange={handleChange}
      />

      <Grid2 size={{ xs: 12, lg: 6 }}>
        <EGInput
          label={t("resources.name")}
          name="name"
          value={resource?.name ?? ""}
          onChange={handleChange}
          required={true}
          isValid={returnIsValid(errors?.name, triedToSave)}
          showSuccessValidation
          showHelpText={false}
        />
      </Grid2>

      <Grid2 size={{ xs: 12, lg: 6 }}>
        <EGInput
          label={t("resources.email")}
          name="email"
          type="email"
          value={resource?.email ?? ""}
          iconName="outline_sms"
          onChange={handleChange}
        />
      </Grid2>

      
      {/* TIPO DE COLABORADOR */}
      <Grid2 size={{ xs: 12, lg: 6 }}>
        <EGBasicSelect
          label={t("resources.collaborator_type")}
          name="collaborator"
          value={resource?.collaborator ?? ""}
          onChange={handleChange}
          options={collaboratorOpts}
          required={true}
          isValid={returnIsValid(errors?.collaborator, triedToSave)}
          showSuccessValidation
          showHelpText={false}
        />
      </Grid2>

      <Grid2 size={{ xs: 12, lg: 4 }}>
        <EGBasicSelect
          label={t("resources.expertise")}
          name="expertise"
          value={resource?.expertise ?? ""}
          onChange={handleChange}
          options={expertiseOpts}
          required={true}
          isValid={returnIsValid(errors?.expertise, triedToSave)}
          showSuccessValidation
          showHelpText={false}
        />
      </Grid2>

      {/* INTERNO O EXTERNO */}
      {
        resource?.collaborator === "internal" &&
        <>
          <Grid2 size={{ xs: 12, lg: 4 }}>
            <EGInput
              label={t("resources.area_or_department")}
              name="area"
              value={resource?.area ?? ""}
              onChange={handleChange}
            />
          </Grid2>

          <Grid2 size={{ xs: 12, lg: 4 }}>
            <EGInput
              label={t("resources.position")}
              name="position"
              value={resource?.position ?? ""}
              onChange={handleChange}
            />
          </Grid2>
        </>
      }


      <Grid2 size={{ xs: 12, lg: 4 }}>
        <EGInput
          label={t("resources.phone")}
          name="phone"
          type="number"
          value={resource?.phone ?? ""}
          onChange={handleChange}
        />
      </Grid2>

      <Grid2
        size={{ xs: 12, lg: 4 }}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <EGButton label={t("resources.investigation_roles_uppercase")} onClick={() => setShowRoles(true)} />
        {
          !activeDetails &&
          <Link
            onClick={() => setActiveDetails(true)}
            underline="hover"
            textAlign="end"
          >
            {t("resources.add_details_plus")}
          </Link>
        }
      </Grid2>

      {
        activeDetails &&
        <Grid2 size={12}>
          <EGInput
            label={t("resources.details")}
            name="details"
            value={resource?.details ?? ""}
            onChange={handleChange}
            type="textarea"
            multiline
            rows={5}
          />
        </Grid2> 
      }

    </>
  )
}

// RECURSOS DE MATERIALES
const MaterialResourcesEdit = ({
  resource,
  errors,
  handleChange,
  triedToSave,
}) => {
  const [t] = useTranslation("investigation");
  return (
    <>
      <Grid2 size={{ xs: 12, lg: 6 }}>
        <EGInput
          label={t("resources.resource")}
          name="resource"
          value={resource?.resource ?? ""}
          onChange={handleChange}
          required={true}
          isValid={returnIsValid(errors?.resource, triedToSave)}
          showSuccessValidation
          showHelpText={false}
        />
      </Grid2>
  
      <Grid2 size={12}>
        <EGInput
          label={t("resources.details")}
          name="details"
          value={resource?.details ?? ""}
          onChange={handleChange}
          type="textarea"
          multiline
          rows={5}
        />
      </Grid2> 
    </>
  )
}